import { useCallback } from 'react';
import { RotateCw } from 'lucide-react';
import styles from './UserManagement.module.css';
import toolbarStyles from '../../../styles/ToolbarButtons.module.css';
import { useStore } from '../../../hooks/useStore';
import { observer } from 'mobx-react-lite';
import EditUserModal from './components/EditUserModal';
import DeleteUserDialog from './components/DeleteUserDialog';
import CommonButton from '../../../components/common-components/button/CommonButton';
import UsersTab from './tabs/UsersTab';
// Gelecekte düzenlenecek - diğer sekmeler yoruma alındı
// import RolesTab from './tabs/RolesTab';
// import RoleClaimsTab from './tabs/RoleClaimsTab';
// import UserRolesTab from './tabs/UserRolesTab';
// import PermissionsTab from './tabs/PermissionsTab';

const UserManagement = () => {
  const { popupStore, userManagementStore } = useStore();

  const handleRefresh = useCallback(() => {
    userManagementStore.refreshGrid();
  }, [userManagementStore]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.headerTitle}>Kullanıcı ve Yetki Yönetimi</h2>
        <div className={styles.headerActions}>
          <CommonButton
            type="refresh"
            onClick={handleRefresh}
            leftIcon={<RotateCw size={18} />}
            className={toolbarStyles.toolbarBtnRefresh}
          >
            Yenile
          </CommonButton>
        </div>
      </div>

      {/* Gelecekte düzenlenecek - sadece Kullanıcılar sekmesi aktif
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={tabIndex} onChange={(_, v) => setTabIndex(v)} ...>
          <Tab icon={<Users />} label="Kullanıcılar" />
          <Tab icon={<Shield />} label="Roller" />
          <Tab icon={<Key />} label="Rol Yetkileri" />
          <Tab icon={<Link2 />} label="Kullanıcı–Rol" />
          <Tab icon={<ListChecks />} label="Yetkiler (referans)" />
        </Tabs>
      </Box>
      */}

      <div className={styles.gridContainer}>
        <UsersTab />
        {/* tabIndex === 1 && <RolesTab /> */}
        {/* tabIndex === 2 && <RoleClaimsTab /> */}
        {/* tabIndex === 3 && <UserRolesTab /> */}
        {/* tabIndex === 4 && <PermissionsTab /> */}
      </div>

      <EditUserModal
        open={popupStore.isEditUserOpen}
        onClose={() => popupStore.setIsEditUserOpen(false)}
      />
      <DeleteUserDialog />
    </div>
  );
};

export default observer(UserManagement);
